module.exports = __webpack_public_path__ + "img/guide4.4a392e4a.png";